export const parseBoolean = (value?: string) => {
	if (!value) {
		return false;
	}

	switch (value) {
		case '1':
		case 'true':
		case 'yes':
			return true;
	}

	return false;
};

export const getSafeValue = (selectValue: any) => {
	if (
		typeof selectValue === 'object' &&
		selectValue !== null &&
		'value' in selectValue
	) {
		return selectValue.value;
	}
	return selectValue;
};
